import React from "react";
import { useLocation, Link } from "react-router-dom";

const allSiteContent = [
  { title: "Services", path: "/services", keywords: ["automation", "consulting", "ai", "sap"] },
  { title: "Projects", path: "/projects", keywords: ["lookapp", "openmro", "lumi", "guesthouse"] },
  { title: "About Us", path: "/about", keywords: ["mission", "vision", "story", "blackbear"] },
  { title: "Contact", path: "/contact", keywords: ["email", "support", "phone", "message"] },
  { title: "Demo", path: "/demo", keywords: ["interactive", "ui", "charts", "search"] },
];

const SearchResults = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("q")?.toLowerCase() || "";

  const filteredResults = allSiteContent.filter((item) => {
    const regex = new RegExp(query, "i");
    return regex.test(item.title) || item.keywords.some((k) => regex.test(k));
  });

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 text-[#111011] dark:text-white px-6 py-20 font-[Inter] transition-colors">
      <h1 className="text-3xl font-bold mb-6" aria-live="polite">
        Search Results for:{" "}
        <span className="text-blue-700 dark:text-blue-400">{query}</span>
      </h1>

      {filteredResults.length > 0 ? (
        <ul className="space-y-4">
          {filteredResults.map((item, idx) => (
            <li key={idx}>
              <Link
                to={item.path}
                className="text-lg font-medium text-blue-700 dark:text-blue-400 hover:underline transition-colors"
              >
                {item.title}
              </Link>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                Related to: {item.keywords.join(", ")}
              </p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 dark:text-gray-400">
          No matching pages found. Try a different keyword.
        </p>
      )}
    </div>
  );
};

export default SearchResults;
